exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.filter-container[data-v-4e9bd7ad] {\r\n    padding: auto;\r\n    margin-left: 20px;\r\n    padding-top: 20px;\n}\n.filter-item[data-v-4e9bd7ad] {\r\n    margin-right: 10px;\n}\r\n", ""]);

// exports
